import { configureI18n } from '@applyboard/ui-utils';
import DynamicForm from "./components/DynamicForm/DynamicForm.json";
import IllustratedErrorState from "./components/IllustratedErrorState/IllustratedErrorState.json";
import NewViewNotice from "./pages/StudentApplication/components/NewViewNotice/NewViewNotice.json";
import RequirementCard from "./components/RequirementCard/RequirementCard.json";
import RequirementEvaluationTable from "./pages/StudentApplication/components/RequirementList/RequirementEvaluationTable/RequirementEvaluationTable.json";
import RequirementList from "./pages/StudentApplication/components/RequirementList/RequirementList.json";
import RequirementPage from "./pages/RequirementPage/RequirementPage.json";
import RoadRunnerWorkflowsPage from "./pages/RoadRunnerWorkflowsPage/RoadRunnerWorkflowsPage.json";
import RoadRunnerWorkflowDetailsPage from "./pages/RoadRunnerWorkflowDetailsPage/RoadRunnerWorkflowDetailsPage.json";
import RoadRunnerWorkflowStepDetailsPage from "./pages/RoadRunnerWorkflowStepDetailsPage/RoadRunnerWorkflowStepDetailsPage.json";
import ApplicationRequirementCard from "./pages/StudentApplication/components/RequirementList/ApplicationRequirementCard/ApplicationRequirementCard.json";
import ProvideAnswersButton from "./pages/StudentApplication/components/RequirementList/ApplicationRequirementCard/ProvideAnswersButton.json";
import PaymentPrompt from "./components/DynamicForm/customComponents/PaymentPrompt/PaymentPrompt.json";
import PaymentFrame from "./components/DynamicForm/customComponents/PaymentFrame/PaymentFrame.json";
import applicationRequirements from "./pages/StudentApplication/data/applicationRequirements.json";
import AddRequirementsButton from "./pages/StudentApplication/components/AddRequirementsButton/AddRequirementsButton.json";
import ExamDetails from "./pages/StudentApplication/components/SideBar/ExamDetails/ExamDetails.json";
import ApplicationDetails from "./pages/StudentApplication/components/SideBar/ApplicationDetails/ApplicationDetails.json";
import RecruitmentPartnerDetails from "./pages/StudentApplication/components/SideBar/RecruitmentPartnerDetails/RecruitmentPartnerDetails.json";
import NotesList from "./pages/StudentApplication/components/NotesList/NotesList.json";
import SideBar from "./pages/StudentApplication/components/SideBar/SideBar.json";
import PaymentDetails from "./pages/StudentApplication/components/SideBar/PaymentDetails/PaymentDetails.json";
import Header from "./pages/StudentApplication/components/Header/Header.json";
import Copyable from "./components/Copyable/Copyable.json";
import ManageApplicationButton from "./pages/StudentApplication/components/ManageApplicationButton/ManageApplicationButton.json";
import IntakesForm from "./pages/StudentApplication/components/IntakesForm/IntakesForm.json";
import ApplicationStepper from "./pages/StudentApplication/components/ApplicationStepper/ApplicationStepper.json";
import ManageBackupProgramsButton from "./pages/StudentApplication/components/ManageBackupProgramsButton/ManageBackupProgramsButton.json";
import UnpublishedProgramsNotice from "./pages/StudentApplication/components/UnpublishedProgramsNotice/UnpublishedProgramsNotice.json";
import CommissionDetails from "./pages/StudentApplication/components/SideBar/CommissionDetails/CommissionDetails.json";
import TextareaWithCharacterLimit from "./components/TextareaWithCharacterLimit/TextareaWithCharacterLimit.json";
export var enUSI18n = {
  AddRequirementsButton: AddRequirementsButton,
  ApplicationDetails: ApplicationDetails,
  ApplicationRequirementCard: ApplicationRequirementCard,
  applicationRequirements: applicationRequirements,
  Copyable: Copyable,
  DynamicForm: DynamicForm,
  ExamDetails: ExamDetails,
  Header: Header,
  IllustratedErrorState: IllustratedErrorState,
  IntakesForm: IntakesForm,
  ManageApplicationButton: ManageApplicationButton,
  NewViewNotice: NewViewNotice,
  NotesList: NotesList,
  PaymentDetails: PaymentDetails,
  PaymentFrame: PaymentFrame,
  PaymentPrompt: PaymentPrompt,
  ProvideAnswersButton: ProvideAnswersButton,
  RecruitmentPartnerDetails: RecruitmentPartnerDetails,
  RequirementCard: RequirementCard,
  RequirementEvaluationTable: RequirementEvaluationTable,
  RequirementList: RequirementList,
  RequirementPage: RequirementPage,
  RoadRunnerWorkflowDetailsPage: RoadRunnerWorkflowDetailsPage,
  RoadRunnerWorkflowsPage: RoadRunnerWorkflowsPage,
  RoadRunnerWorkflowStepDetailsPage: RoadRunnerWorkflowStepDetailsPage,
  SideBar: SideBar,
  ApplicationStepper: ApplicationStepper,
  ManageBackupProgramsButton: ManageBackupProgramsButton,
  UnpublishedProgramsNotice: UnpublishedProgramsNotice,
  CommissionDetails: CommissionDetails,
  TextareaWithCharacterLimit: TextareaWithCharacterLimit
};
var i18n = configureI18n({
  'en-US': enUSI18n
});
export default i18n;